import React from "react";
import "../App.css";
import { useHistory, useLocation } from "react-router-dom";
import { Button } from "reactstrap";
import back from "../assets/back.png";
import VideoCmp from "./VideoCmp";

const Videos = () => {
  const location = useLocation();
  const model = location.state.model;
  const library_type = location.state.type;
  var history = useHistory();

  return (
    <div className="main">
      <div
        className="titlebar"
        style={{ backgroundColor: "#f2f2f2", padding: 10, margin: -15 }}
      >
        <div style={{ color: "blue" }}>
          {model.title} {">"} Videos
        </div>
      </div>
      <div style={{ marginTop: 20 }}>
        <img
          onClick={() => {
            console.log("click");
            history.goBack();
          }}
          src={back}
          style={{ width: 30, height: 30, marginTop: 10, marginRight: 10 }}
          className="icon-btn"
        />

        <Button
          className="btn-block btn-submit"
          style={{ width: 150, borderWidth: 0, marginTop: 10, fontSize: 16 }}
          onClick={() => {
            console.log("click");
            history.push({
              pathname: "/upload-videos",
              state: { model: model, type: library_type },
            });
          }}
        >
          Add Videos
        </Button>

        <div>
          <div style={{ marginTop: 10 }}></div>
          <VideoCmp model={model} />
        </div>
      </div>
    </div>
  );
};

export default Videos;
